import { publicRequest } from '../../requestMeth';

const authHeaders = token => ({ token: `Bearer ${token}` });

const toFailure = error => {
  const rawMessage = error.response?.data?.message;
  const translatedMessages = {
    'Validation failed': 'Los datos enviados no son válidos.',
    'Internal Server Error': 'Ocurrió un error interno. Intentá nuevamente.',
    'Unauthorized': 'La sesión no está autorizada para realizar esta operación.',
    'Forbidden': 'No tenés permisos para realizar esta operación.',
  };
  const failure = new Error(translatedMessages[rawMessage] || rawMessage || 'No se pudo completar la operación.');
  failure.status = error.response?.status;
  failure.details = error.response?.data?.details;
  return failure;
};

export function createCalculationModelsApi(token) {
  const request = async (method, url, data, featureRoute = true) => {
    try {
      return (await publicRequest.request({
        method,
        url: featureRoute ? `calculation-models${url}` : url,
        data,
        headers: authHeaders(token),
      })).data;
    } catch (error) {
      throw toFailure(error);
    }
  };

  return {
    nodeTypes: () => request('get', '/node-types'),
    listModels: companyId => request('get', `/?companyId=${encodeURIComponent(companyId)}`),
    createModel: payload => request('post', '/', payload),
    model: modelId => request('get', `/${modelId}`),
    version: (modelId, versionId) => request('get', `/${modelId}/versions/${versionId}`),
    createDraft: modelId => request('post', `/${modelId}/drafts`),
    saveDraft: (modelId, versionId, payload) => request('put', `/${modelId}/versions/${versionId}/draft`, payload),
    validate: (modelId, versionId) => request('post', `/${modelId}/versions/${versionId}/validate`),
    publish: (modelId, versionId) => request('post', `/${modelId}/versions/${versionId}/publish`),
    execute: (modelId, versionId, payload) => request('post', `/${modelId}/versions/${versionId}/execute`, payload),
    projectEconomicImpact: (projectId, payload) => request('post', `projects/${projectId}/economic-impact`, payload, false),
    projectBindings: projectId => request('get', `/project-bindings?projectId=${encodeURIComponent(projectId)}`),
    bindProject: payload => request('post', '/project-bindings', payload),
    branches: () => request('get', 'master/companies?type=branch_offices', undefined, false),
    devices: () => request('get', 'admin/devices', undefined, false),
    basicParameters: deviceId => request('get', `basic_parameters?deviceId=${encodeURIComponent(deviceId)}`, undefined, false),
    calculatedParameters: deviceId => request('get', `calculated_parameters?deviceId=${encodeURIComponent(deviceId)}`, undefined, false),
  };
}
